import React from "react";
import "./effects.css";

/**
 * A pulsing red glow around the edges of the screen. Shown to every player while the Fascists could
 * win by electing Hitler (nomination and voting, with three or more Fascist policies enacted).
 */
export default function HitlerZoneVignette(props: {
  active: boolean;
}): React.ReactElement | null {
  if (!props.active) {
    return null;
  }
  return <div className="hz-vignette" aria-hidden="true" />;
}
